import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { AppShell, type SeccionItem } from "@/components/shell/AppShell";
import { OperativoProvider } from "@/lib/operativo-store";
import { CatalogoProductos } from "@/components/operativo/CatalogoProductos";
import { ConfiguradorCargos } from "@/components/operativo/ConfiguradorCargos";
import { SolicitudCredito } from "@/components/operativo/SolicitudCredito";
import { TablaProgramada } from "@/components/operativo/TablaProgramada";
import { RegistroPagos } from "@/components/operativo/RegistroPagos";
import { EstadoCuentaView } from "@/components/operativo/EstadoCuentaView";
import { LineaRevolvente } from "@/components/operativo/LineaRevolvente";
import { Building2 } from "lucide-react";

const TITULO = "Simulador Operativo — Machote Meta Patrimonio";
const DESC =
  "Motor operativo de crédito: catálogo de productos, comisiones CONDUSEF, comisión circular, calendario de pagos, aplicación de pagos con prelación e intereses moratorios y estado de cuenta ejecutivo en MXN.";

export const Route = createFileRoute("/operativo")({
  head: () => ({
    meta: [
      { title: TITULO },
      { name: "description", content: DESC },
      { property: "og:title", content: TITULO },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: OperativoPage,
});

const SECCIONES: SeccionItem[] = [
  { id: "productos", label: "Productos" },
  { id: "cargos", label: "Comisiones y gastos" },
  { id: "solicitud", label: "Solicitud" },
  { id: "calendario", label: "Calendario" },
  { id: "pagos", label: "Aplicación de pagos" },
  { id: "estado", label: "Estado de cuenta" },
  { id: "revolvente", label: "Línea Revolvente" },
];

function OperativoPage() {
  const [activa, setActiva] = useState<string>("productos");

  return (
    <OperativoProvider>
      <AppShell
        titulo={TITULO}
        subtitulo="Motor operativo real · Estado en memoria · Cálculo 100% en el navegador · Moneda MXN"
        icono={<Building2 className="h-5 w-5 text-primary-foreground" />}
        rutaActiva="/operativo"
        secciones={SECCIONES}
        activa={activa}
        onActiva={setActiva}
        pie="Machote operativo con fines demostrativos. Las reglas de negocio (RN-01 a RN-08), el CAT y la prelación de pagos replican la operación de la entidad; no constituye una oferta de crédito."
      >
        {activa === "productos" && <CatalogoProductos />}
        {activa === "cargos" && <ConfiguradorCargos />}
        {activa === "solicitud" && <SolicitudCredito />}
        {activa === "calendario" && <TablaProgramada />}
        {activa === "pagos" && <RegistroPagos />}
        {activa === "estado" && <EstadoCuentaView />}
        {activa === "revolvente" && <LineaRevolvente />}
      </AppShell>
    </OperativoProvider>
  );
}
